import { defineCommand } from '../../../concepts/commands/CommandDefinition';
import { EditorSession } from '../EditorSession';
import { RootOverride } from '../RootOverride';
import { Selection, SelectionSet } from '../Selection';
import { resolveSubject } from './CommandUtil';

export const drill = defineCommand(
    'drill',
    null,
    (r, [target]: [string?]) => {

        const session = r.call(EditorSession);
        const subject = resolveSubject(r, target);

        session.update(Selection, SelectionSet.empty);
        session.update(RootOverride, subject);

    },
    []
);
